/**
 * 入口文件
 * @author wdzxc
 */

import $wd from '../packages/utils';
import {$Dialog, $Loading} from '../packages/tlcm';
import {ListLoader, PageIndexNav} from '../packages/pagination';
import FileUploader from '../packages/upload';
import InterfaceProxy from '../packages/interface';

$wd.FileUploader = FileUploader;
$wd.InterfaceProxy = InterfaceProxy;
$wd.$Dialog = $Dialog;
$wd.$Loading = $Loading;
$wd.ListLoader = ListLoader;
$wd.PageIndexNav = PageIndexNav;

if (window) {
    window.$wd = $wd;
    window.$Dialog = $Dialog;
    window.$Loading = $Loading;
    window.ListLoader = ListLoader;
    window.PageIndexNav = PageIndexNav;
    window.FileUploader = FileUploader;
    window.InterfaceProxy = InterfaceProxy;
}

export default $wd;
export {
    $wd,
    FileUploader,
    InterfaceProxy,
    $Dialog,
    $Loading,
    ListLoader,
    PageIndexNav
}

